import { TableCell, StatusCell } from 'ui/tableCell';
import { ThirdPartyActionButton } from './components/ThirdPartyActionButton';
import type { ColumnData } from './types';

/**
 * Form Field Names
 */
export const ID = 'id';
export const PROJECT_ID = 'projectId';
export const API_TOKEN = 'apiToken';
export const ANALYTICS_PROVIDER = 'analyticsProvider';
export const ANALYTICS_REGION = 'analyticsRegion';
export const ENABLED = 'enabled';

/** Columns for table shown in all orgs table */
export const COLUMNS: ColumnData[] = [
  {
    name: 'ID',
    align: 'flex-start',
    value: 'id',
    RowCell: ({ row }) => <TableCell>{row.id}</TableCell>,
  },
  {
    name: 'Integration',
    align: 'flex-start',
    value: 'analyticsProvider',
    RowCell: ({ row }) => (
      <TableCell data-test="row-analytics-provider">{row.analyticsProvider}</TableCell>
    ),
  },
  {
    name: 'Region',
    align: 'flex-start',
    value: 'analyticsRegion',
    RowCell: ({ row }) => <TableCell>{row.analyticsRegion}</TableCell>,
  },
  {
    name: 'Enabled',
    align: 'flex-start',
    value: 'enabled',
    RowCell: ({ row }) => <StatusCell data-test="row-enabled" showPositiveState={row.enabled} />,
  },
  {
    name: 'API Key',
    align: 'flex-start',
    value: 'apiToken',
    RowCell: ({ row }) => <TableCell data-test="row-api-key">{row.apiToken}</TableCell>,
  },
  {
    name: '',
    align: 'flex-start',
    value: '',
    sortable: false,
    RowCell: ({ row }) => <ThirdPartyActionButton integration={row} />,
  },
];
